module.exports = __webpack_public_path__ + "img/rays.928f6fe9.svg";